<template>
  <b-row class="bg-primary text-center contactAExpert">
    <b-col lg="1" class="p-4 mt-auto mb-auto">
      <back-button />
    </b-col>
    <b-col lg="10" class="p-4">
      <h2 class="text-white contactAExpertText">
        <b-link target="_blank" class="card-link" href="/contact-us"
          ><span class="bookExpert">Book a Teams Tour</span></b-link>
          with one of our experts
      </h2>
      <h2 class="text-white contactAExpertText"
        v-if="!hideRegisterSection">
        or
        <b-link target="_blank" class="card-link pr-1"
          @click="oidcAuthenticate"
          ><span class="bookExpert"
            >register</span></b-link
        >and try it yourself.
      </h2>
    </b-col>
  </b-row>
</template>

<script>

import BackButton from '@/components/BackButton.vue';
import { mapActions } from 'vuex';
import oidcAuth from '@/mixins/oidcAuth';

import {
  BCol,
  BLink,
  BRow,
} from 'bootstrap-vue';

export default {
  components: {
    BackButton,
    BCol,
    BLink,
    BRow,
  },
  computed: {
    contactUsHref: () => 'https://www.afrigis.co.za/contact-us/#sendMessage',
    hideRegisterSection() {
      return this.disableRegisterSection || this.oidcIsAuthenticated;
    },
  },
  methods: {
    ...mapActions({
      oidcAuthenticate: 'oidcStore/authenticateOidc',
    }),
  },
  props: {
    disableRegisterSection: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [oidcAuth],
};
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .contactAExpertText {
    font-size: 1.2rem!important;
  }
}
</style>
